// @ts-nocheck


import React from 'react';



import { CalculationEconomy, DistributionEconomy, ProposalEconomy } from '.';
import Contracts from '../../summary/components/Contracts/Form';











export default (props) => {
  const {
    id,
    orgUnitId,
    branchBudgetSummary,
    setBranchBudgetSummary,
    expandedRows,
    budgetSummary,
    onSubmit
  } = props;

  const getComponents = () => {
    switch (props.type) {
      case 'distribution-economy':
        return (
          <DistributionEconomy
            id={id}
            orgUnitId={orgUnitId}
            expandedRows={expandedRows}
            branchBudgetSummary={branchBudgetSummary}
            setBranchBudgetSummary={setBranchBudgetSummary} />);


      case 'proposal-economy':
        return (
          <ProposalEconomy
            id={id}
            orgUnitId={orgUnitId}
            expandedRows={expandedRows}
            branchBudgetSummary={branchBudgetSummary}
            setBranchBudgetSummary={setBranchBudgetSummary} />);


      case 'contracts':
        return (
          <Contracts
            id={id}
            orgUnitId={orgUnitId}
            budgetSummary={budgetSummary}
            branchBudgetSummary={branchBudgetSummary} />);


      default:
        return (
          <CalculationEconomy
            id={id}
            orgUnitId={orgUnitId}
            expandedRows={expandedRows}
            branchBudgetSummary={branchBudgetSummary}
            budgetSummary={budgetSummary}
            setBranchBudgetSummary={setBranchBudgetSummary}
            onSubmit={onSubmit} />);


    }
  };

  return getComponents();
};
